import * as React from 'react';
import { connect } from 'react-redux';
import { resetIntelligentPhotoCaptureToastAction } from '../actions';
import { IntelligentAssignmentSummaryToastComponent } from '../components';
import { getPhotoCaptureToastNotification } from '../selectors';
const mapStateToProps = (state) => ({
    toastNotification: getPhotoCaptureToastNotification(state)
});
const mapDispatchToProps = (dispatch) => ({
    onResetToast: () => {
        dispatch(resetIntelligentPhotoCaptureToastAction());
    }
});
const IntelligentAssignmentSummaryToastComponentWrapper = (props) => {
    return React.createElement(IntelligentAssignmentSummaryToastComponent, Object.assign({}, props));
};
export const ConnectedIntelligentAssignmentSummaryToastComponent = connect(mapStateToProps, mapDispatchToProps)(IntelligentAssignmentSummaryToastComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentAssignmentSummaryToastComponent.js.map